import { useMutation, useQueryClient } from "@tanstack/react-query";
import { salveazaTargetareMapareCod } from "@/api/endpoints/targetareConfig";
import { queryKeys } from "@/lib/queryClient";

export function useSalveazaTargetareMapareCod() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: salveazaTargetareMapareCod,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.targetare.mapare() });
      queryClient.invalidateQueries({
        queryKey: queryKeys.targetare.scoruri(),
      });
      queryClient.invalidateQueries({ queryKey: queryKeys.targetare.stats() });
    },
  });
}
